export default __webpack_public_path__ + "static/media/pin.9bb06f23.svg";